import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const reg = new URLSearchParams(window.location.search).get("reg");
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
        <XCircle className="mx-auto text-[#FF7F27]" size={64} />
        <h1 className="text-2xl font-black brand-navy mt-4">Pago cancelado</h1>
        <p className="text-slate-500 mt-2">No se ha realizado ningún cargo. Tu inscripción no está confirmada.</p>
        <button onClick={() => navigate(-1)} className="mt-8 bg-brand-orange text-white font-bold rounded-full px-8 py-3 hover:bg-[#E56A15] transition-colors">Volver a intentarlo</button>
      </div>
    </div>
  );
}
